export class MPAInterceptedResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "actionApprovalRequest",
            "baseName": "actionApprovalRequest",
            "type": "MPARequest",
            "format": ""
        },
        {
            "name": "mpaPolicies",
            "baseName": "mpaPolicies",
            "type": "MPAInterceptedResponseMpaPolicies",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return MPAInterceptedResponse.attributeTypeMap;
    }
    constructor() {
    }
}
